import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

const ERRORS = `errors { path, message }`;

const PADDLE_SERVICE_FIELDS = `
  id
  name
  code
  serviceFeePercent
  additionalFeePercent
  buyFeePercent
  sort
  presaleScreen
  applySalesTaxByDefault
`;

const PADDLE_SERVICE_VARIABLES = `
  $name: String!
  $code: String!
  $serviceFeePercent: Decimal!
  $additionalFeePercent: Decimal!
  $sort: Int!
  $presaleScreen: Boolean
  $applySalesTaxByDefault: Boolean
`;

const PADDLE_SERVICE_ARGUMENTS = `
  name: $name
  code: $code
  serviceFeePercent: $serviceFeePercent
  additionalFeePercent: $additionalFeePercent
  sort: $sort
  presaleScreen: $presaleScreen
  applySalesTaxByDefault: $applySalesTaxByDefault
`;

const PADDLE_SERVICE_FIELDS_AND_ERRORS = `
  paddleService {
    ${PADDLE_SERVICE_FIELDS}
  }
  ${ERRORS}
`;

export const PADDLE_SERVICES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    paddleServicesWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${PADDLE_SERVICE_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_PADDLE_SERVICE = gql`
  mutation CreatePaddleService(
    ${PADDLE_SERVICE_VARIABLES}
  ) {
    createPaddleService(
      ${PADDLE_SERVICE_ARGUMENTS}
    ) {
      paddleService { ${PADDLE_SERVICE_FIELDS} }
      errors { path, message }
    }
  }
`;

export const UPDATE_PADDLE_SERVICE = gql`
  mutation UpdatePaddleService(
    $id: ID!
    ${PADDLE_SERVICE_VARIABLES}
  ) {
    updatePaddleService(
      id: $id
      ${PADDLE_SERVICE_ARGUMENTS}
    ) {
      ${PADDLE_SERVICE_FIELDS_AND_ERRORS}
    }
  }
`;

export const PADDLE_SERVICE = gql`
  query PaddleService($id: ID!) {
    paddleService(id: $id) {
      ${PADDLE_SERVICE_FIELDS}
    }
  }
`;

export const HIDE_PADDLE_SERVICE = gql`
  mutation HidePaddleService($id: ID!) {
    hidePaddleService(id: $id) {
      paddleService {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_PADDLE_SERVICE = gql`
  mutation UnhidePaddleService($id: ID!) {
    unhidePaddleService(id: $id) {
      paddleService {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
